// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root___CPWg","name":"ConsentHeader_name__1zctb","birthday":"ConsentHeader_birthday__bSrKj","skeleton":"ConsentHeader_skeleton__3RS3v"};